<template>
  <div class="pg-component-select">
    <div class="pg-component-select__top">
      <span class="pg-component-select__title">组件</span>
      <i class="el-icon-lock"></i>
      <i class="el-icon-unlock"></i>
      <i class="el-icon-circle-close"></i>
    </div>
    <div class="pg-component-select__seach">
      <PgInput prefix-icon="el-icon-search" v-model="keyword" @enter="getComponents" />
    </div>
    <div class="pg-component-select__components">
      <div class="pg-component-select__component" v-for="item in componentData" :key="item.id">
        <i class="el-icon-orange"></i>
        <span class="pg-component-select__component-text">{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { post } from '../../../utils/index'
import { ref, shallowRef, onMounted } from 'vue'

const componentData = shallowRef([])
const keyword = ref('')
const getComponents = async () => {
  const [res] = await post('rest/excomp/dict/componentPaged', {
    pageNo: 1,
    totalCount: 0,
    pageSize: 1000,
    parameters: {
      lead: 'WEB',
      keyword: keyword.value,
    },
    criteriaCode: 'EXCOMP_DICT_COMPONENT_PAGED',
  })
  componentData.value = res?.data ?? []
}
onMounted(getComponents)
</script>

<style lang="scss">
@import '../style/component-select.scss';
</style>
